import type { FC } from 'react';
import React, { createRef, useState } from 'react';

import { Popover } from 'Storybook/core/Popover';

import DownloadCSVButton from '../DownloadCSVButton/DownloadCSVButton';
import { DownloadCSVPopoverContent } from '../DownloadCSVPopoverContent/DownloadCSVPopoverContent';

import type { DownloadCSVButtonWithPopoverProps } from './DownloadCSVButtonWithPopover.types';

import styles from './DownloadCSVButtonWithPopover.module.scss';

export const DownloadCSVButtonWithPopover: FC<DownloadCSVButtonWithPopoverProps> = ({
	className,
	cypressId,
	dynamicDownloadOptions,
	isDisabled,
	isLoading,
	onClick,
	onHover,
	tooltip,
}) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const ref = createRef<HTMLButtonElement>();

	const {
		alignment = 'center',
		cypressId: downloadButtonCypressId,
		items,
		onDownloadButtonClick,
		title,
	} = dynamicDownloadOptions;

	const onClickHandler = () => {
		onClick?.();
		setIsOpen(true);
	};

	const onDownloadHandler = async (selected: string) => {
		onDownloadButtonClick?.(selected);
		setIsOpen(false);
	};

	const content = (
		<DownloadCSVPopoverContent
			cypressId={downloadButtonCypressId}
			items={items}
			onDownloadClick={onDownloadHandler}
			title={title}
		/>
	);

	return (
		<Popover
			modal
			content={content}
			contentAlign={alignment}
			contentClassName={styles.popoverContent}
			contentSide="bottom"
			contentSideOffset={14}
			onOpenChange={(open) => setIsOpen(open)}
			open={isOpen && !isLoading}
			trigger={
				<DownloadCSVButton
					ref={ref}
					className={className}
					cypressId={cypressId}
					isDisabled={isDisabled}
					isLoading={isLoading}
					isPopoverOpen={isOpen}
					onClick={onClickHandler}
					onHover={onHover}
					tooltip={tooltip}
				/>
			}
		/>
	);
};
